import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from '../../../styles.module.css';
import { Breadcrumb, CTSinput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";

const normalizeResult = (value) => {
  if (!value) return '';
  const val = String(value).trim().toLowerCase();
  return val.charAt(0).toUpperCase() + val.slice(1);
};

const EmptyCylinderInspectionDetails = () => {
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;

  const [data, setData] = useState({
    entry_no: editData ? editData.entry_no : '',
    entry_date: editData?.entry_date
      ? new Date(editData.entry_date).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0],
    shift: editData ? editData.shift : 'shift1',
    shift_time: editData ? editData.shift_time : '08:00',
    done_by: editData ? editData.done_by : '',
    fin_year: editData ? editData.fin_year : '2025-2026',
  });

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (editData && typeof editData.tableData === 'string') {
      try {
        const parsedTableData = JSON.parse(editData.tableData);
        const normalizedTableData = parsedTableData.map(row => ({
          ...row,
          valve_condition: normalizeResult(row.valve_condition),
          fusible_plug: normalizeResult(row.fusible_plug),
          painting: normalizeResult(row.painting),
          cyl_cap_avl: normalizeResult(row.cyl_cap_avl),
          eci_result: normalizeResult(row.eci_result),
          remarks: row.remarks ? normalizeResult(row.remarks) : '',
        }));
        setTableData(normalizedTableData);
      } catch (e) {
        console.error("Invalid JSON in tableData:", editData.tableData, e);
        setTableData([]);
      }
    }
  }, [editData]);

  const shiftOptions = [
    { label: 'Shift 1', value: 'shift1' },
    { label: 'Shift 2', value: 'shift2' },
    { label: 'Shift 3', value: 'shift3' },
  ];

  const getResultColor = (result) => {
    return result === 'Ok' ? 'green' : result === 'Not Ok' ? 'red' : 'inherit';
  };

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: 'Empty Cylinder Inspection Details' }]} />
        <Box sx={{ display: 'flex' }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item xs={12}>
              <Typography className={`${styles.header_txt}`}>
                Inspection Details
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
            <Grid item xs={12} sm={5.5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                <Typography className={`${styles.label_Txt}`}>Entry No</Typography>
                <CTSinput
                  size="small"
                  fullWidth
                  name="entry_no"
                  value={data.entry_no}
                  InputProps={{
                    readOnly: true,
                    className: styles.CTSinput_Box,
                    style: { backgroundColor: '#f0f0f0' },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={5.5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                <Typography className={`${styles.label_Txt}`}>Entry Date</Typography>
                <CTSinput
                  size="small"
                  fullWidth
                  type="date"
                  name="entry_date"
                  value={data.entry_date}
                  InputProps={{
                    readOnly: true,
                    className: styles.CTSinput_Box,
                    style: { backgroundColor: '#f0f0f0' },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={5.5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                <Typography className={`${styles.label_Txt}`}>Shift</Typography>
                <CTSinput
                  size="small"
                  fullWidth
                  value={shiftOptions.find((s) => s.value === data.shift)?.label || data.shift}
                  InputProps={{
                    readOnly: true,
                    className: styles.CTSinput_Box,
                    style: { backgroundColor: '#f0f0f0' },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={5.5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                <Typography className={`${styles.label_Txt}`}>Shift Time</Typography>
                <CTSinput
                  size="small"
                  fullWidth
                  type="time"
                  name="shift_time"
                  value={data.shift_time}
                  InputProps={{
                    readOnly: true,
                    className: styles.CTSinput_Box,
                    style: { backgroundColor: '#f0f0f0' },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={5.5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                <Typography className={`${styles.label_Txt}`}>Inspection Done By</Typography>
                <CTSinput
                  size="small"
                  fullWidth
                  name="done_by"
                  value={data.done_by}
                  InputProps={{
                    readOnly: true,
                    className: styles.CTSinput_Box,
                    style: { backgroundColor: '#f0f0f0' },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Paper sx={{ width: '100%' }}>
                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                  <Table size="small" stickyHeader>
                    <TableHead className={styles.table_head_container}>
                      <StyledTableRow>
                        <StyledTableCell sx={{ width: '8% !important' }} align="center" className={`${styles.table_head}`}>Sr No</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Cyl No</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Tag No</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Valve Condition</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Fusible Plug</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Painting</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Cyl Cap Avl</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Result</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Current Tare Wt</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Actual Tare Wt</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Actual Tare Wt (After Solvent)</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Qty Of Solvent</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Acetone Drum Tag No</StyledTableCell>
                        <StyledTableCell sx={{ width: '10%' }} align="left" className={`${styles.table_head}`}>Remarks</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                      {tableData.length > 0 ? (
                        tableData.map((row, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell sx={{ width: '8% !important' }} align="center" className={`${styles.CTSinput_Box}`}>
                              {index + 1}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.cylinder_no}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.tag_no}
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{
                                width: '10% !important',
                                color: row.valve_condition === 'Ok' ? 'green' : row.valve_condition === 'Not Ok' ? 'red' : 'inherit',
                              }}
                              align="left"
                              className={`${styles.list_table_body}`}
                            >
                              {row.valve_condition}
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{
                                width: '10% !important',
                                color: row.fusible_plug === 'Ok' ? 'green' : row.fusible_plug === 'Not Ok' ? 'red' : 'inherit',
                              }}
                              align="left"
                              className={`${styles.list_table_body}`}
                            >
                              {row.fusible_plug}
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{
                                width: '10% !important',
                                color: row.painting === 'Ok' ? 'green' : row.painting === 'Not Ok' ? 'red' : 'inherit',
                              }}
                              align="left"
                              className={`${styles.list_table_body}`}
                            >
                              {row.painting}
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{
                                width: '10% !important',
                                color: row.cyl_cap_avl === 'Ok' ? 'green' : row.cyl_cap_avl === 'Not Ok' ? 'red' : 'inherit',
                              }}
                              align="left"
                              className={`${styles.list_table_body}`}
                            >
                              {row.cyl_cap_avl}
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{
                                width: '10% !important',
                                color: getResultColor(row.eci_result),
                              }}
                              align="left"
                              className={`${styles.list_table_body}`}
                            >
                              {row.eci_result === 'Ok' ? 'Passed' : row.eci_result === 'Not Ok' ? 'Not Passed' : row.eci_result}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.current_tare_wt}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.actual_tare_wt}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.actual_tare_wt_aft_sol}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.qty_solvent}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.acetone_drum_tag_no}
                            </StyledTableCell>
                            <StyledTableCell sx={{ width: '10% !important' }} align="left" className={`${styles.list_table_body}`}>
                              {row.remarks || 'N/A'}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                      ) : (
                        <StyledTableRow>
                          <StyledTableCell colSpan={14} align="center">
                            No cylinder data available
                          </StyledTableCell>
                        </StyledTableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyCylinderInspectionDetails;